<template>
  <time
    :key="date"
    :class="classList"
    :datetime="dateJs?.format()"
    v-html="dateToHtml"
  />
</template>

<script setup lang="ts">

import dayjs from 'dayjs/esm/index.js'
import utc from 'dayjs/esm/plugin/utc'
import timezone from 'dayjs/esm/plugin/timezone'
import formatDateToHtml from './utils/format-date-to-html'
import transformFormatToDateTime from './utils/format-datetime-to-date'

dayjs.extend(utc)
dayjs.extend(timezone)

const props = defineProps({
	  date: {
	    type: Date,
	    required: true
	  },
	  format: {
		  // @https://day.js.org/docs/en/display/format
	    type: String,
	    default: 'DD/MM/YYYY, HH:mm'
	  },
	  locale: {
	    type: Object
	  },
	  timezone: {
    type: String,
	    default: 'Europe/Amsterdam'
	  }
})

const dateJs = dayjs.utc(props.date).tz(props.timezone)
const dateToHtml = computed(() => formatDateToHtml(dateJs, transformFormatToDateTime(dateJs, props.format), props.locale))

const newDate = new Date()
const finalDate = dayjs().utc(newDate).tz(props.timezone)
const yearIsCurrent = dateJs.year() === finalDate.year()
const monthIsCurrent = dateJs.month() === finalDate.month()

const dateOrDateTime = dateToHtml?.value?.includes('class="hour"')

const classList = [props?.locale?.name, yearIsCurrent ? 'current-year' : null, monthIsCurrent ? 'current-month' : null, dateOrDateTime ? 'date-time' : 'date'].filter(Boolean).join(' ')

</script>
